import React from 'react';
import { useAppName } from '../hooks/useAppName';
import { useAppPublisher } from '../hooks/useAppPublisher';
import { useBeta } from '../hooks/useBeta';
import { Sprite } from './sprite';

interface Props {
  children: React.ReactNode
  bannerContent?: React.ReactNode
}

export const AuthLayout: React.FC<Props> = ({ children, bannerContent }) => {
  const publisher = useAppPublisher();
  const appName = useAppName();
  const isBeta = useBeta();

  return (
    <div className="flex md:flex-row flex-col min-h-screen">
      <div className="flex-1 bg-red md:max-h-[unset] max-h-[100px]">
        {bannerContent && (
          <div className="md:sticky md:top-0 md:h-screen h-[100px]">
            {bannerContent}
          </div>
        )}
      </div>
      <div className="relative flex-1 flex flex-col md:pt-11 pt-6 md:max-w-[630px] bg-white overflow-hidden">
        <div className="absolute z-[1] pl-[63px]">
          <Sprite name="ambient-apple" className="fill-dirty-white w-[770px] h-[926px]" />
        </div>
        <div className="relative z-[2] flex-1 px-8">
          <div className="w-full max-w-[384px] mx-auto">
            <header>
              <div className="flex flex-row">
                <div>
                  <Sprite name="bhd-bordered-logo" className="md:block hidden h-[56px] w-[56px]" />
                </div>
                <div className="relative h-full pl-2">
                  <div className="flex flex-col justify-center py-[6px]">
                    <div className="flex flex-row">
                      <h3 className="font-bold text-xl leading-7 text-black">{appName}</h3>
                      <div className="pl-1 flex flex-col justify-start">
                        {isBeta && (
                          <div className="rounded-full leading-4 bg-white-dirty-light font-semibold text-[10px] px-1 border border-gray-light">
                            BETA
                          </div>
                        )}
                      </div>
                    </div>
                    <div>
                      <h3 className="text-xs leading-[0.9rem] text-gray-dark tracking-[0.08em] mt-[2px]">ADMINISTRATION</h3>
                    </div>
                  </div>
                </div>
              </div>
            </header>
            <main className="flex-1 md:mt-[44px]">{children}</main>
          </div>
        </div>
        <footer className="relative z-[2] mt-11 min-h-[65px]">
          <div className="border-t border-gray-medium w-full" />
          <div className="py-6 text-center">
            <p className="text-gray">
              ©
              {' '}
              {publisher}
            </p>
          </div>
        </footer>
      </div>
    </div>
  );
};

AuthLayout.defaultProps = {
  bannerContent: undefined,
};
